import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AlertsConfiguration } from '../../types/Devices';
import { getDeviceAlertSettingsByDeviceId } from '../../services/DeviceService';

function useGetDeviceAlertSettingsByDeviceId(id:string, fleetId: string, alertName: string): UseQueryResult<AlertsConfiguration> {
  return useQuery(
    ['device-alerts-settings', id, fleetId, alertName],
    async (): Promise<AlertsConfiguration> => getDeviceAlertSettingsByDeviceId(id, fleetId, alertName),
    {
      retry: 0,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: !!id,
    },
  );
}

export default useGetDeviceAlertSettingsByDeviceId;
